import Settings from '../icons/Settings'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Modal from './Modal'
import TutorChoseDeviceModal from './TutorChoseDeviceModal'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import OutlinedButtonWithLoader from './OutlinedButtonWithLoader'
import { CREATE_ROOM, RESET_ROOM_CREATED } from '../redux/janusReducer'
import { useParams } from 'react-router-dom'

interface Props {
  setScreen: (val: 'chose-device' | 'lesson') => void
}

const TutorChoseDeviceScreen = ({ setScreen }: Props) => {
  const [showModal, setShowModal] = useState(false)
  const videoRef = useRef<null | HTMLVideoElement>(null)
  const cameraId = useSelector((state: RootReducer) => state.tutorChannelReducer.selectedCameraId)
  const microphoneId = useSelector((state: RootReducer) => state.tutorChannelReducer.selectedMicrophoneId)
  const isStudentPresent = useSelector((state: RootReducer) => state.tutorChannelReducer.isStudentPresent)
  const roomCreated = useSelector((state: RootReducer) => state.janusReducer.roomCreated)
  const { lessonId } = useParams()
  const dispatch = useDispatch()

  const startLesson = () => {
    dispatch(CREATE_ROOM({ id: lessonId ?? '0' }))
  }

  useEffect(() => {
    if (roomCreated) {
      setScreen('lesson')
    }
  }, [roomCreated, setScreen])

  useEffect(() => {
    return () => {
      dispatch(RESET_ROOM_CREATED())
    }
  }, [dispatch])

  const startLocalStream = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: cameraId ? { exact: cameraId } : undefined },
        audio: { deviceId: microphoneId ? { exact: microphoneId } : undefined }
      })
      if (videoRef.current) {
        videoRef.current.srcObject = stream
        videoRef.current.play()
      }
    } catch (err) {
      console.error('Error accessing media devices.', err)
    }
  }, [cameraId, microphoneId])

  useEffect(() => {
    startLocalStream()
  }, [cameraId, microphoneId, startLocalStream])

  return (
    <div className="font-sans">
      <div className="max-w-[80rem] mx-auto px-2 ml--2 mr--2">
        <Modal
          isOpen={showModal}
          toggleModal={() => {
            setShowModal((val) => !val)
          }}>
          <TutorChoseDeviceModal
            type="tutor"
            closeModal={() => {
              setShowModal(false)
            }}
          />
        </Modal>
        <div className="h-20" />
        <div className="flex flex-wrap">
          <div className="w-[25rem]">
            <div className="bg-black h-[20rem] rounded-lg relative overflow-hidden">
              <video
                webkit-playsinline
                controls={false}
                playsInline
                ref={videoRef}
                muted
                className="w-full h-full object-cover"
              />
              <div
                onClick={() => {
                  setShowModal(true)
                }}
                className="text-red w-14 h-14 text-slateGray bg-white p-3 rounded-full opacity-80 cursor-pointer absolute bottom-2 left-[40%]">
                <Settings />
              </div>
            </div>
          </div>
          <div className="md:w-5 h-2 w-full" />
          <div className="flex justify-end items-center md:items-start flex-col flex-1">
            {isStudentPresent ? (
              <p className="text-slateGray text-16">Student is waiting click button to start lesson</p>
            ) : (
              <p className="text-slateGray text-16">Student is not present yet</p>
            )}
            <div className="h-2" />
            <div className="w-[20rem]">
              <OutlinedButtonWithLoader disabled={!isStudentPresent} label="Start Lesson" onClick={startLesson} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TutorChoseDeviceScreen
